import { render, staticRenderFns } from "./JobSorting.vue?vue&type=template&id=4b5cb4af&scoped=true"
import script from "./JobSorting.vue?vue&type=script&lang=js"
export * from "./JobSorting.vue?vue&type=script&lang=js"
import style0 from "./JobSorting.vue?vue&type=style&index=0&id=4b5cb4af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cb4af",
  null
  
)

export default component.exports